interface AiErrorMessage {
    location?: { search: string };
    hasAllowAiValue: boolean;
}

export default function getAiErrorMessage({
    hasAllowAiValue,
    location,
}: AiErrorMessage): string | null {
    return !hasAllowAiValue && location && location.search.includes('brief_missing_required_fields')
        ? __('Please answer the question to continue.')
        : null;
}
